export const ACCESS_RIGHTS = {

  //#region CORE
  CORE_SECURITY_USERS: 1001,
  CORE_SECURITY_ROLES: 1002,
  CORE_SECURITY_AUDITLOGS: 1003,
  CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER: 1004,
  CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR: 1005,
  CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER: 1006,
  //#endregion

  //#region NATIONAL ACADEMY OF SPORTS
  NAS_STATICDATA_BUILDINGLOCATIONS: 2201,
  NAS_STATICDATA_GUIDANCECOUNSELORSESSIONTYPES: 2202,
  NAS_STATICDATA_CLINICVISITTYPES: 2203,
  NAS_STATICDATA_CLOCKINDEVICES: 2204,
  NAS_STATICDATA_GRADELEVELS: 2205,
  NAS_STATICDATA_SECTIONS: 2206,
  NAS_STATICDATA_RFIDCARDS: 2207,
  NAS_STATICDATA_ROOMS: 2208,
  NAS_STATICDATA_SPORTS: 2209,
  NAS_STATICDATA_GUIDANCEVISITTYPES: 2210,
  NAS_STATICDATA_INCIDENTSANCTIONS: 2211,

  NAS_STUDENTS: 2301,
  NAS_STUDENTS_ASSIGNRFID: 2302,
  NAS_STUDENTS_REMOVERFID: 2303,
  NAS_TRANSACTIONS_CHECKINS: 2304,
  NAS_TRANSACTIONS_CLINICVISITS: 2305,
  NAS_TRANSACTIONS_GUIDANCECOUNSELORVISITS: 2306,
  NAS_TRANSACTIONS_DORMITORYVISITS: 2307,
  NAS_STUDENTS_MEDICALINFO: 2308,
  NAS_STUDENTS_LOGS: 2309,
  NAS_STUDENTS_UPDATE_ROOM: 2310,
  NAS_TRANSACTIONS_MERITS: 2311,
  //#endregion
} 